
import { API_endpoints } from "../config";

export const getProfileStatusChanges = async (offset = 0, limit = 10): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.getProfileStatusChanges, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ offset, limit }),
        });

        if (!response.ok) {
            throw new Error("Fehler beim Laden von Tarif Daten.");
        }

        return await response.json();
    } catch (error) {
        console.error("Fehler beim Laden von Tarif Daten:", error);
        throw error;
    }
};